import type { OAuthProvider } from 'src/app/auth/domain/models/oauth-provider'

export const CURRENT_TERMS_VERSION = 'tos-v1.0' as const

export const POLICY_API_VERSION = '1.0' as const

// eslint-disable-next-line @typescript-eslint/ban-types
export type TermsVersionId = typeof CURRENT_TERMS_VERSION | (string & {})

export interface ITermsAcceptance {
  provider: OAuthProvider
  versionId: TermsVersionId
  acceptedAtUtc: string
}
